import { combineReducers } from "@reduxjs/toolkit";
import venueDetailsReducer from "./venueSlice";
import venuesReducer from "./venuesSlice";
import mapOrdersReducer from "./mapOrdersSlice";
import userReducer from "./userSlice";
import appReducer from "./appSlice";
import overviewSlice from "./overviewSlice";
import jsMapSlice from "./jsMapSlice";
export default combineReducers({
    app: appReducer,
    venue: venueDetailsReducer,
    venues: venuesReducer,
    mapOrders: mapOrdersReducer,
    user: userReducer,
    overview: overviewSlice,
    jsMap: jsMapSlice,
});
